"use client";
import React from "react";
import { useRouter } from "next/navigation"; 
import styles from "../../ui/SubmitSuccessModal/SubmitSuccessModal.module.css";
import Image from "next/image";

interface SubmitSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const SubmitSuccessModal: React.FC<SubmitSuccessModalProps> = ({ open, onClose }) => {
  const router = useRouter(); 
  if (!open) return null;

  const handleClose = () => {
    onClose(); 
    router.push("/");} 

  return (
    <div className={styles.overlay}>
      <div className={styles.modalCenter}>
        <button
          type="button"
          aria-label="Close success modal"
          className={styles.closeButton}
          onClick={handleClose}
        >
          ×
        </button>

        <div className={styles.submitFormContainer}>
          <Image
            src="/images/enquiryform/enquirysucessimg.png"
            alt="Success Icon"
            width={80}
            height={80}
            className={styles.iconImage}
          />
          <h2 className={styles.formTitle}>Form Submitted Successfully</h2>
          <p className={styles.formDesc}>We will get back to you soon</p>
        </div>
      </div>
    </div>
  );
};

export default SubmitSuccessModal;
